import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "feed-desktop-aside" }
const _hoisted_2 = { class: "feed-widget-card__profile" }
const _hoisted_3 = { class: "feed-widget-card__profile-copy" }
const _hoisted_4 = { class: "feed-widget-card__title" }
const _hoisted_5 = { class: "feed-widget-card__subtitle" }
const _hoisted_6 = {
  key: 0,
  class: "feed-widget-card__badge"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "feed-widget-card__stats"
}
const _hoisted_9 = { class: "feed-widget-card__stat-value" }
const _hoisted_10 = { class: "feed-widget-card__stat-label" }
const _hoisted_11 = { class: "feed-widget-card" }
const _hoisted_12 = { class: "feed-widget-card__links" }
const _hoisted_13 = { class: "feed-widget-card feed-widget-card--muted" }
const _hoisted_14 = {
  key: 0,
  class: "feed-widget-card__body"
}
const _hoisted_15 = {
  key: 1,
  class: "feed-widget-card__body"
}
const _hoisted_16 = {
  key: 2,
  class: "feed-widget-card__event-list"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "feed-widget-event__thumb feed-widget-event__thumb--empty"
}
const _hoisted_19 = { class: "feed-widget-event__copy" }
const _hoisted_20 = { class: "feed-widget-event__name" }
const _hoisted_21 = { class: "feed-widget-event__meta" }
const _hoisted_22 = {
  key: 0,
  class: "feed-widget-event__location"
}

import {computed, inject, onMounted, Ref, ref} from 'vue';
import {useIonRouter} from '@ionic/vue';
import {DateTime} from 'luxon';
import UserAvatar from '@/components/UserAvatar.vue';
import ApiService from '@/services/api/apiService';
import {EventInterface} from '@/interfaces/EventInterface';
import {UserInterface} from '@/interfaces/UserInterface';


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedDesktopSidebar',
  setup(__props) {

const ionRouter = useIonRouter();
const user = inject<Ref<UserInterface | undefined>>('user');

const upcomingEvents = ref<EventInterface[]>([]);
const eventsLoading = ref(true);

const profileStats = computed(() => {
  if (!user?.value) return [];
  return [
    {label: 'Friends', value: user.value.friends ?? 0},
    {label: 'Posts', value: user.value.posts ?? 0},
    {label: 'Followers', value: user.value.followers ?? 0},
  ];
});

const pickRandomEvents = (events: EventInterface[], count = 3) => {
  const pool = [...events];
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool.slice(0, count);
};

const loadUpcomingEvents = async () => {
  eventsLoading.value = true;
  try {
    const response = await ApiService.Events().paginate(1);
    upcomingEvents.value = pickRandomEvents(response.data ?? [], 3);
  } catch {
    upcomingEvents.value = [];
  } finally {
    eventsLoading.value = false;
  }
};

onMounted(loadUpcomingEvents);

const formatEventDate = (event: EventInterface) => {
  const raw = event?.starts_at;
  if (!raw) return '';
  const dt = DateTime.fromISO(String(raw));
  return dt.isValid ? dt.toFormat("EEE d MMM · HH:mm") : '';
};

const goTo = (name: string) => {
  ionRouter.navigate({name}, 'forward', 'push');
};

const goToProfile = () => {
  goTo('Profile');
};

const goToFeedPreferences = () => {
  goTo('PineappleFeedPreferences');
};

const viewEvent = (event: EventInterface) => {
  ionRouter.navigate({
    name: 'Event',
    params: {
      eventId: event.id,
    },
  }, 'forward', 'push');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    (_unref(user))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "feed-widget-card feed-widget-card--interactive",
          onClick: goToProfile
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(UserAvatar, {
              user: _unref(user),
              size: "14",
              class: "feed-widget-card__avatar"
            }, null, 8, ["user"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(user).name), 1),
              _createElementVNode("div", _hoisted_5, [
                (_unref(user).id_verified)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Verified"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, "Complete your profile"))
              ])
            ])
          ]),
          (profileStats.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileStats.value, (stat) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: stat.label,
                    class: "feed-widget-card__stat"
                  }, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(stat.value), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(stat.label), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "feed-widget-card__cta" }, "View profile", -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "feed-widget-card__title" }, "Discover", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "feed-widget-card__body" }, " Browse events, search members, and connect with people in the community. ", -1)),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          type: "button",
          class: "feed-widget-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goTo('Events')))
        }, "Events"),
        _createElementVNode("button", {
          type: "button",
          class: "feed-widget-link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (goTo('Search')))
        }, "Search"),
        _createElementVNode("button", {
          type: "button",
          class: "feed-widget-link",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (goTo('Flirt')))
        }, "Chat")
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "feed-widget-card__title" }, "Upcoming events", -1)),
      (eventsLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Loading events…"))
        : (!upcomingEvents.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, " No upcoming events right now. Check back soon or host your own. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(upcomingEvents.value, (event) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: event.id,
                  type: "button",
                  class: "feed-widget-event",
                  onClick: ($event: any) => (viewEvent(event))
                }, [
                  (event.photo_url)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle({ backgroundImage: `url('${event.photo_url}')` }),
                        class: "feed-widget-event__thumb"
                      }, null, 4))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("svg", {
                          class: "h-4 fill-current text-brand-light-gray/30",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 640 512"
                        }, [
                          _createElementVNode("path", { d: "M159.2 12.6c5.7-10.5 18.1-15.2 29.3-11.1L320 49.3 451.5 1.5c11.2-4.1 23.7 .7 29.3 11.1l81.6 151c32.4 60.1 10.6 133.3-45.6 167L552.6 429l55.2-20.1c12.5-4.5 26.2 1.9 30.8 14.3s-1.9 26.2-14.3 30.8l-77.8 28.3-77.8 28.3c-12.5 4.5-26.2-1.9-30.8-14.3s1.9-26.2 14.3-30.8l55.2-20.1-35.8-98.5c-61.2 9.4-121.7-29.6-136.3-92.5L320 188.6l-15.3 65.8c-14.6 62.9-75.1 101.9-136.3 92.5l-35.8 98.5 55.2 20.1c12.5 4.5 18.9 18.3 14.3 30.8s-18.3 18.9-30.8 14.3L93.6 482.3 15.8 454C3.3 449.4-3.1 435.7 1.5 423.2s18.3-18.9 30.8-14.3L87.4 429l35.8-98.4c-56.2-33.7-78.1-106.9-45.6-167l81.6-151zm32.4 41L156.8 118 277 161.7l16.5-71L191.6 53.6z" })
                        ], -1)
                      ]))])),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(event.name), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(formatEventDate(event)), 1),
                    (event.location)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(event.location), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_17))
              }), 128))
            ])),
      _createElementVNode("button", {
        type: "button",
        class: "feed-widget-link feed-widget-link--inline",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (goTo('Events')))
      }, " Browse all events ")
    ]),
    _createElementVNode("div", { class: "feed-widget-card feed-widget-card--muted" }, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "feed-widget-card__title" }, "Feed tips", -1)),
      _cache[10] || (_cache[10] = _createElementVNode("p", { class: "feed-widget-card__body" }, " Use feed preferences to fine-tune what appears in For You, and toggle NSFW reveal when you are subscribed. ", -1)),
      _createElementVNode("button", {
        type: "button",
        class: "feed-widget-link feed-widget-link--inline",
        onClick: goToFeedPreferences
      }, " Open feed preferences ")
    ])
  ]))
}
}

})